import React, { useEffect, useState } from "react";
import styles from "./NewsletterModal.module.scss";

import _ from "../../../i18n";
import {
  DAYS,
  NL_PLANS,
  SELECT_STYLES,
  SELECT_STYLES_NEWSLETTER,
  TTP_API_URL,
} from "../../../config";
import Select from "react-select";
import CollaboratorBlock from "./CollaboratorBlock";
import Loader from "../Loader";
import { toast } from "react-toastify";
import Switch from "../Switch/Switch";
import CollaboratorFrom from "./CollaboratorFrom";
import IconPlus from "../icons/IconPlus";
import { useSelector } from "react-redux";
import IconAlertTriangle from "../icons/IconAlertTriangle";
import classNames from "classnames";
import { getNewsletterThemes } from "../../../api/newsletter";
import IconExternalLink from "../icons/IconExternalLink";
import IconClose from "../icons/IconClose";

const NewsletterSettings = ({
  newsletterPlan,
  frequency,
  setFrequency,
  frequencyTabs,
  selectedDay,
  setSelectedDay,
  isAutomaticNewsletter,
  setIsAutomaticNewsletter,
  selectedWeek,
  setSelectedWeek,
  selectedHour,
  setSelectedHour,
  selectedMinutes,
  setSelectedMinutes,
  collaborators,
  senders,
  setSenders,
  setSlide,
  verifiedEmailsList,
  handleFetchVerifiedEmails,
  isVerifiedEmailsLoading,
  isLogoUaVisible,
  setIsLogoUaVisible,
  domains,
  handleVerifyDomain,
  setSelectedDomain,
  activeFrequencyTab,
  setActiveFrequencyTab,
  activeConfig,
  updateActiveConfig,
  isVerifying,
  setIsVerifying,
}) => {
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const auth = useSelector((state) => state.auth);
  const [collaboratorList, setCollaboratorList] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isOpenTemplateModal, setIsOpenTemplateModal] = useState(null);
  const [templatesList, setTemplatesList] = useState([]);
  const [templatesPage, setTemplatesPage] = useState(0);
  const [templatesHasMore, setTemplatesHasMore] = useState(true);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [previewThemeId, setPreviewThemeId] = useState(null);

  const Periods = [
    {
      index: "BY_TWO_WEEKS",
      choices: [
        { value: "FIRST_WEEK", label: _("week_desc_1") },
        { value: "SECOND_WEEK", label: _("week_desc_2") },
      ],
    },
    {
      index: "BY_MONTH",
      choices: [
        { value: "FIRST_WEEK", label: _("first_week") },
        { value: "SECOND_WEEK", label: _("second_week") },
        { value: "THIRD_WEEK", label: _("third_week") },
        { value: "FOURTH_WEEK", label: _("fourth_week") },
      ],
    },
  ];

  const hours = Array.from({ length: 24 }, (_, i) => ({
    value: i < 10 ? `0${i}` : `${i}`,
    label: i < 10 ? `0${i}` : `${i}`,
  }));

  const minutes = Array.from({ length: 60 }, (_, i) => ({
    value: i < 10 ? `0${i}` : `${i}`,
    label: i < 10 ? `0${i}` : `${i}`,
  }));

  useEffect(() => {
    if (isVerifiedEmailsLoading) return;
    const collab_list =
      collaborators?.map((collaborator) => {
        const matchedEmail = verifiedEmailsList.find(
          (emailObj) => emailObj.email === collaborator.mainEmail
        );
        return {
          value: collaborator.id,
          label: `${collaborator.firstName} ${collaborator.lastName}`,
          email: collaborator.mainEmail,
          status: matchedEmail ? matchedEmail.VerificationStatus : "Failed",
        };
      }) ?? [];
    setCollaboratorList(collab_list);
  }, [isVerifiedEmailsLoading, collaborators, verifiedEmailsList]);

  useEffect(() => {
    if (!auth.token || !fiduciary?.id) return;
    loadTemplates(0);
  }, [auth.token, fiduciary?.id]);

  const handleRemoveClick = (sender) => {
    setSenders(senders.filter((item) => item.value !== sender.value));

    if (!collaboratorList.some((item) => item.email === sender.email)) {
      setCollaboratorList([sender, ...collaboratorList]);
    }
  };
  const handleChangeSelectedWeek = (el) => {
    setFrequency(el);
    if (el.value === "BY_WEEK") {
      setSelectedWeek("");
    } else if (el.value === "BY_TWO_WEEKS") {
      setSelectedWeek({ value: "FIRST_WEEK", label: _("week_desc_1") });
    } else {
      setSelectedWeek({ value: "FIRST_WEEK", label: _("first_week") });
    }
  };

  const LANGUAGE_OPTIONS = [
    { value: "FR", label: _("french") },
    { value: "NL", label: _("dutch") },
    { value: "EN", label: _("english") },
  ];

  const handleNewslettersPerPeriodChange = (opt) => {
    const count = opt.value;
    const existing = activeConfig.schedules;
    const updated = [...existing];
    while (updated.length < count) {
      updated.push({
        id: updated.length + 1,
        day: DAYS[0],
        hour: { value: "08", label: "08" },
        minutes: { value: "00", label: "00" },
      });
    }
    const langs = [...activeConfig.languages];
    while (langs.length < count) {
      langs.push({ id: langs.length + 1, language: "FR" });
    }
    updateActiveConfig({
      newslettersPerPeriod: count,
      schedules: updated.slice(0, count),
      languages: langs.slice(0, count),
    });
  };

  const handleLanguageChange = (index, value) => {
    const updated = [...activeConfig.languages];
    updated[index] = { ...updated[index], language: value };
    updateActiveConfig({ languages: updated });
  };

  const handleScheduleChange = (index, field, value) => {
    const updated = [...activeConfig.schedules];
    updated[index] = { ...updated[index], [field]: value };
    updateActiveConfig({ schedules: updated });
  };

  const handleAssociateTemplate = (index) => {
    setIsOpenTemplateModal(index);
  };

  // Nouvelle fonction appelée quand l'user confirme dans le modal
  const handleConfirmTemplate = (themeId) => {
    const updated = [...activeConfig.schedules];
    updated[templateModalIndex] = { ...updated[templateModalIndex], themeId };
    updateActiveConfig({ schedules: updated });
    setIsOpenTemplateModal(null); // ferme le modal
  };

  const handleRemoveTemplate = (index) => {
    const updated = [...activeConfig.schedules];
    updated[index] = { ...updated[index], themeId: null };
    updateActiveConfig({ schedules: updated });
  };
  const currentSchedules = activeConfig.schedules ?? [];

  const loadTemplates = (page = 0) => {
    if (templatesLoading || (!templatesHasMore && page > 0)) return;

    setTemplatesLoading(true);

    getNewsletterThemes({
      token: auth.token,
      clientId: fiduciary.id,
      limit: 20,
      offset: page * 20,
    }).then((res) => {
      const newItems = res.data.data.map((t) => ({
        value: t.id,
        label: t.name,
      }));

      setTemplatesList((prev) =>
        page === 0 ? newItems : [...prev, ...newItems]
      );
      setTemplatesHasMore(newItems.length === 20);
      setTemplatesPage(page);
      setTemplatesLoading(false);
    });
  };
  const getPreviewUrl = (themeId) => {
    return `${TTP_API_URL}/mailing/web-version?themeId=${themeId}&textModelId=&access_token=${auth.token}`;
  };
  return (
    <div className={"cell small-12 medium-12"}>
      <div
        className={`grid-x
            ${styles.config}`}
      >
        <div
          className={`cell small-12 medium-2 
            ${styles.mail_list}`}
        >
          <span className={styles.title}> {_("define_sender")}</span>
          <span className={styles.sub_title}>
            {" "}
            {_("manage_sending_emails")}
          </span>
          <div className={`grid-x ${styles.container_select}`}>
            <div className={`cell small-10 ${styles.sender_select}`}>
              {isVisible ? (
                <p className={styles.sender_title}>{_("new_sender")}</p>
              ) : (
                <Select
                  styles={SELECT_STYLES}
                  className={styles.sender_options}
                  options={collaboratorList.filter(
                    (item) =>
                      !senders
                        .map((sender) => sender.value)
                        .includes(item.value)
                  )}
                  isSearchable={true}
                  isClearable={false}
                  value={""}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  onChange={(e) => {
                    if (
                      (newsletterPlan === "LITE" && senders.length === 0) ||
                      (["PERSONALIZED", "STANDARD"].includes(newsletterPlan) &&
                        senders.length < 20)
                    ) {
                      setSenders([e, ...senders]);
                      setCollaboratorList(
                        collaboratorList.filter(
                          (collaborator) => collaborator.value !== e.value
                        )
                      );
                    } else {
                      toast.info(
                        _(
                          "Vous avez atteint la limite des expéditeurs prévue par ce plan "
                        )
                      );
                    }
                  }}
                  isLoading={isVerifiedEmailsLoading}
                />
              )}
            </div>
            <div
              className={`cell small-2 ${styles.sender_add_icon}`}
              onClick={() => {
                setIsVisible(!isVisible);
              }}
            >
              <IconPlus
                style={{
                  transform: isVisible ? "rotate(-45deg)" : "rotate(0deg)",
                  transition: "transform 0.5s ease",
                }}
              />
            </div>
          </div>
          <div className={styles.separator} />
          {senders.length > 0 && !isVisible && (
            <span className={styles.senders_count}>
              {senders.length} expéditeur(s) :
            </span>
          )}
          <div className={styles.senders_list}>
            {isVerifiedEmailsLoading ? (
              <Loader
                style={{ height: "13px", margin: "15% 30%" }}
                color={"#06d9b1"}
              />
            ) : isVisible ? (
              <CollaboratorFrom
                collaboratorList={collaboratorList}
                setCollaboratorList={setCollaboratorList}
                senders={senders}
                setSenders={setSenders}
                setIsVisible={setIsVisible}
              />
            ) : (
              senders.length > 0 &&
              senders.map((sender) => (
                <CollaboratorBlock
                  key={sender.value}
                  sender={sender}
                  removeClick={handleRemoveClick}
                  verifiedEmailsList={verifiedEmailsList}
                  handleFetchVerifiedEmails={handleFetchVerifiedEmails}
                  domains={domains}
                  handleVerifyDomain={handleVerifyDomain}
                  setSlide={setSlide}
                  setSelectedDomain={setSelectedDomain}
                  isVerifying={isVerifying}
                  setIsVerifying={setIsVerifying}
                />
              ))
            )}
          </div>
        </div>
        <div
          className={`cell small-12 medium-10 
            ${styles.config_details}`}
        >
          <div className={styles.details}>
            <span className={styles.title}>
              {_("program_nl_title")}
              {
                NL_PLANS.filter((plan) => plan.value === newsletterPlan)[0]
                  .label
              }
              )
            </span>
            {fiduciary.uaMode !== "OECCBB_MEMBER" && (
              <span className={styles.title_link} onClick={() => setSlide(1)}>
                {_("change_plan")}
              </span>
            )}
          </div>
          <span className={styles.sub_title}> {_("program_nl_desc")}</span>

          <div className={styles.config_block}>
            {newsletterPlan === "PERSONALIZED" && (
              <div className={styles.show_logo}>
                <span className={styles.details_title}>Logo UA :</span>
                <Switch
                  isChecked={isLogoUaVisible}
                  onChange={() => setIsLogoUaVisible(!isLogoUaVisible)}
                />
              </div>
            )}
            <div className={styles.config_item}>
              <span className={styles.details_title}>
                {_("articles_option_3")} :
              </span>
              <Select
                styles={{
                  ...SELECT_STYLES_NEWSLETTER,
                  multiValueRemove: (base) =>
                    newsletterPlan !== "PERSONALIZED"
                      ? { ...base, display: "none" }
                      : base,
                }}
                options={frequencyTabs}
                isSearchable={false}
                isClearable={false}
                isMulti={true}
                value={frequency}
                onChange={(selected) => setFrequency(selected || [])}
                isDisabled={newsletterPlan !== "PERSONALIZED"}
              />
            </div>

            {newsletterPlan === "PERSONALIZED" && (
              <>
                {frequency.length > 1 && (
                  <div className={styles.frequency_tabs}>
                    {frequency.map((f) => (
                      <button
                        key={f.value}
                        className={classNames(
                          styles.frequency_tab,
                          activeFrequencyTab === f.value &&
                            styles.frequency_tab_active
                        )}
                        onClick={() => setActiveFrequencyTab(f.value)}
                      >
                        {f.label}
                      </button>
                    ))}
                  </div>
                )}
                <div
                  className={
                    frequency.length > 1
                      ? styles.multi_tab_block
                      : styles.multi_tab
                  }
                >
                  <div className={styles.config_item}>
                    <span className={styles.details_title}>
                      {_("newsletters_count")}:
                    </span>
                    <div className={styles.time_select}>
                      <Select
                        styles={SELECT_STYLES}
                        isSearchable={false}
                        isClearable={false}
                        value={{
                          value: activeConfig.newslettersPerPeriod,
                          label: activeConfig.newslettersPerPeriod,
                        }}
                        options={[1, 2, 3, 4].map((n) => ({
                          value: n,
                          label: n,
                        }))}
                        onChange={handleNewslettersPerPeriodChange}
                      />
                    </div>
                  </div>
                  {activeConfig.newslettersPerPeriod > 1 ? (
                    <>
                      {/* Warning */}
                      <div className={styles.planning_warning}>
                        <IconAlertTriangle />
                        <div>
                          <strong>{_("planning_per_newsletter")}</strong>
                          <p>{_("planning_per_newsletter_desc")}</p>
                          <p>
                            <s>{_("planning_single_slot")}</s> →{" "}
                            {_("planning_dedicated_slot")}
                          </p>
                        </div>
                      </div>

                      {/* Header tableau */}
                      <div className={styles.planning_individual_header}>
                        <span>• {_("planning_individual")}</span>
                      </div>

                      {/* Colonnes */}
                      <table className={styles.planning_table}>
                        <thead>
                          <tr>
                            <th></th>
                            <th>{_("planning_col_language")}</th>
                            <th>{_("planning_col_day")}</th>
                            <th>{_("planning_col_hour")}</th>
                            <th>{_("template")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentSchedules.map((schedule, index) => {
                            const lang = activeConfig.languages[index];
                            const tpl = schedule.themeId;
                            return (
                              <tr key={schedule.id}>
                                <td className={styles.planning_nl_name}>
                                  {_("newsletter_label")} {index + 1}
                                </td>

                                <td>
                                  <Select
                                    styles={SELECT_STYLES}
                                    options={LANGUAGE_OPTIONS}
                                    isClearable={false}
                                    isSearchable={false}
                                    value={LANGUAGE_OPTIONS.find(
                                      (l) => l.value === lang?.language
                                    )}
                                    onChange={(e) =>
                                      handleLanguageChange(index, e.value)
                                    }
                                  />
                                </td>

                                <td>
                                  <Select
                                    styles={SELECT_STYLES}
                                    options={DAYS}
                                    isSearchable={false}
                                    isClearable={false}
                                    value={schedule.day}
                                    onChange={(e) =>
                                      handleScheduleChange(index, "day", e)
                                    }
                                  />
                                </td>

                                <td>
                                  <div className={styles.time_cell}>
                                    <Select
                                      styles={SELECT_STYLES}
                                      options={hours}
                                      isSearchable={false}
                                      isClearable={false}
                                      value={schedule.hour}
                                      onChange={(e) =>
                                        handleScheduleChange(index, "hour", e)
                                      }
                                    />
                                    <span>:</span>
                                    <Select
                                      styles={SELECT_STYLES}
                                      options={minutes}
                                      isSearchable={false}
                                      isClearable={false}
                                      value={schedule.minutes}
                                      onChange={(e) =>
                                        handleScheduleChange(
                                          index,
                                          "minutes",
                                          e
                                        )
                                      }
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className={styles.template_cell}>
                                    <Select
                                      styles={SELECT_STYLES}
                                      options={templatesList}
                                      isClearable={true}
                                      isSearchable={true}
                                      isLoading={templatesLoading}
                                      filterOption={() => true}
                                      placeholder="Choisir un template..."
                                      value={
                                        templatesList.find(
                                          (t) => t.value === schedule.themeId
                                        ) ?? null
                                      }
                                      onChange={(e) => {
                                        const updated = [
                                          ...activeConfig.schedules,
                                        ];
                                        updated[index] = {
                                          ...updated[index],
                                          themeId: e ? e.value : null,
                                        };
                                        updateActiveConfig({
                                          schedules: updated,
                                        });
                                      }}
                                      onMenuScrollToBottom={() => {
                                        if (
                                          templatesHasMore &&
                                          !templatesLoading
                                        ) {
                                          loadTemplates(templatesPage + 1);
                                        }
                                      }}
                                      onInputChange={(search, { action }) => {
                                        if (action === "input-change") {
                                          // reset et recherche
                                          setTemplatesPage(0);
                                          setTemplatesHasMore(true);
                                          setTemplatesList([]);
                                          getNewsletterThemes({
                                            token: auth.token,
                                            clientId: fiduciary.id,
                                            search: search || null,
                                            limit: 20,
                                            offset: 0,
                                          }).then((res) => {
                                            const items = res.data.data.map(
                                              (t) => ({
                                                value: t.id,
                                                label: t.name,
                                              })
                                            );
                                            setTemplatesList(items);
                                            setTemplatesHasMore(
                                              items.length === 20
                                            );
                                          });
                                        }
                                      }}
                                    />
                                    {schedule.themeId &&
                                      templatesList.find(
                                        (t) => t.value === schedule.themeId
                                      ) && (
                                        <button
                                          className={styles.voir_btn}
                                          onClick={() =>
                                            setPreviewThemeId(schedule.themeId)
                                          }
                                        >
                                          <i className="icon-ttp-eye" />
                                          {_("preview")}
                                        </button>
                                      )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </>
                  ) : (
                    // Case newslettersPerPeriod === 1
                    <>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("planning_day")} :
                        </span>
                        <Select
                          styles={SELECT_STYLES}
                          options={DAYS}
                          isSearchable={false}
                          isClearable={false}
                          value={activeConfig.planningDay ?? DAYS[0]}
                          onChange={(e) =>
                            updateActiveConfig({ planningDay: e })
                          }
                        />
                      </div>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("planning_hour")} :
                        </span>
                        <div className={styles.time_select}>
                          <Select
                            styles={SELECT_STYLES}
                            options={hours}
                            isSearchable={false}
                            isClearable={false}
                            value={
                              activeConfig.planningHour ?? {
                                value: "08",
                                label: "08",
                              }
                            }
                            onChange={(e) =>
                              updateActiveConfig({ planningHour: e })
                            }
                          />
                        </div>
                        <span className={styles.space}>:</span>
                        <div className={styles.minute_select}>
                          <Select
                            styles={SELECT_STYLES}
                            options={minutes}
                            isSearchable={false}
                            isClearable={false}
                            value={
                              activeConfig.planningMinutes ?? {
                                value: "00",
                                label: "00",
                              }
                            }
                            onChange={(e) =>
                              updateActiveConfig({ planningMinutes: e })
                            }
                          />
                        </div>
                      </div>
                      <div className={styles.config_item}>
                        <span className={styles.details_title}>
                          {_("template")} :
                        </span>
                        <div className={styles.template_cell}>
                          <Select
                            styles={SELECT_STYLES}
                            options={templatesList}
                            isClearable={true}
                            isSearchable={true}
                            isLoading={templatesLoading}
                            filterOption={() => true}
                            placeholder="Choisir un template..."
                            value={
                              templatesList.find(
                                (t) => t.value === activeConfig.themeId
                              ) ?? null
                            }
                            onChange={(e) =>
                              updateActiveConfig({
                                themeId: e ? e.value : null,
                              })
                            }
                            onMenuScrollToBottom={() => {
                              if (templatesHasMore && !templatesLoading) {
                                loadTemplates(templatesPage + 1);
                              }
                            }}
                            onInputChange={(search, { action }) => {
                              if (action === "input-change") {
                                setTemplatesPage(0);
                                setTemplatesHasMore(true);
                                setTemplatesList([]);
                                getNewsletterThemes({
                                  token: auth.token,
                                  clientId: fiduciary.id,
                                  search: search || null,
                                  limit: 20,
                                  offset: 0,
                                }).then((res) => {
                                  const items = res.data.data.map((t) => ({
                                    value: t.id,
                                    label: t.name,
                                  }));
                                  setTemplatesList(items);
                                  setTemplatesHasMore(items.length === 20);
                                });
                              }
                            }}
                          />
                          {activeConfig.themeId &&
                            templatesList.find(
                              (t) => t.value === activeConfig.themeId
                            ) && (
                              <button
                                className={styles.voir_btn}
                                onClick={() =>
                                  setPreviewThemeId(activeConfig.themeId)
                                }
                              >
                                <i className="icon-ttp-eye" />
                                {_("preview")}
                              </button>
                            )}
                        </div>
                      </div>
                    </>
                  )}{" "}
                </div>
              </>
            )}
            {/*<div className={styles.automatic_check}>
              <input
                type="checkbox"
                className={styles.styled_checkbox}
                id="my_checkbox"
                checked={isAutomaticNewsletter}
                onChange={() =>
                  setIsAutomaticNewsletter(!isAutomaticNewsletter)
                }
              />
              <label htmlFor="my_checkbox">
                Envoyer la campagne automatiquement
              </label>
            </div>*/}
            {/* {isAutomaticNewsletter && (
              <>
                <div className={styles.separator} />
                <span className={styles.title}> {_("choose_date")} : </span>
                <span className={styles.sub_title}>
                  {_("choose_date_desc")}
                </span>

                <div className={styles.config_item}>
                  <span className={styles.details_title}>Jour :</span>
                  <Select
                    isDisabled={!isAutomaticNewsletter}
                    styles={SELECT_STYLES}
                    options={DAYS}
                    isSearchable={false}
                    isClearable={false}
                    value={selectedDay}
                    onChange={e => setSelectedDay(e)}
                  />
                </div>
                {frequency.value !== "BY_WEEK" && (
                  <div className={styles.config_item}>
                    <span className={styles.details_title}>{_("week")} :</span>
                    <Select
                      isDisabled={!isAutomaticNewsletter}
                      styles={SELECT_STYLES}
                      options={
                        Periods.filter(
                          period => period.index === frequency.value
                        )[0]?.choices
                      }
                      isSearchable={false}
                      isClearable={false}
                      value={selectedWeek}
                      onChange={e => setSelectedWeek(e)}
                    />
                  </div>
                )}

                <div className={styles.config_item}>
                  <span className={styles.details_title}>Heure :</span>
                  <div className={styles.time_select}>
                    <Select
                      isDisabled={!isAutomaticNewsletter}
                      styles={SELECT_STYLES}
                      options={hours}
                      isSearchable={false}
                      isClearable={false}
                      value={selectedHour}
                      onChange={e => setSelectedHour(e)}
                    />
                  </div>
                  <span className={styles.space}>:</span>
                  <div className={styles.minute_select}>
                    <Select
                      isDisabled={!isAutomaticNewsletter}
                      styles={SELECT_STYLES}
                      options={minutes}
                      isSearchable={false}
                      isClearable={false}
                      value={selectedMinutes}
                      onChange={e => setSelectedMinutes(e)}
                    />
                  </div>
                </div>
              </>
            )}*/}
          </div>
        </div>
        {/* <div
          className={`cell small-12 medium-2 
            ${styles.config_dates}`}
        >
          <span className={styles.title}> {_("off_dates_title")} </span>
          <div className={styles.calendar}>
            <span>{_("coming_soon")}</span>
          </div>
        </div>*/}
      </div>
      {/* Modal aperçu template */}
      {previewThemeId && (
        <div
          className={styles.preview_overlay}
          onClick={() => setPreviewThemeId(null)}
        >
          <div
            className={styles.preview_modal}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className={styles.preview_close}
              onClick={() => setPreviewThemeId(null)}
            >
              <IconClose size={14} />{" "}
            </div>
            {/* Header avec URL + bouton fermer */}
            <div className={styles.preview_header}>
              <input
                className={styles.preview_url}
                value={getPreviewUrl(previewThemeId)}
                readOnly
              />
              <a
                href={getPreviewUrl(previewThemeId)}
                target="_blank"
                rel="noreferrer"
                className={styles.preview_open}
              >
                <IconExternalLink size={18} />
              </a>
            </div>
            {/* Iframe */}
            <div className={styles.preview_body}>
              <iframe
                src={getPreviewUrl(previewThemeId)}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Aperçu template"
              />
            </div>{" "}
          </div>
        </div>
      )}
      {/*  <Modal
        contentLabel="Modal"
        onRequestClose={onClose}
        shouldCloseOnOverlayClick={true}
        isOpen={isOpen}
        style={getModalStyle(customModalStyle, viewerStyle)}
      >
        <div className="viewer viewer--modal" style={{ ...customStyle }}>
          {!isBillingPreview && (
            <div className="viewer__close" onClick={onClose}>
              <img src={"/img/icons/" + SVG_ICONS["CLOSE"]} />
            </div>
          )}
          <div
            className={`viewer__container small-12 ${children ? `medium-${right}` : ""} flex-2-3`}
          >
            {url && (
              <div className="viewer__container__goto">
                <input value={url} readOnly={true} />
                <a href={url} target="_blank">
                <img src={"/img/icons/" + SVG_ICONS["OPEN_LINK"]}/>
              </a>
              </div>
            )}
            <div
              className={
                "viewer__container__content" +
                (loading || !preview ? " gradiant" : "")
              }
            >
              <iframe {...attr} />
            </div>
          </div>
          {children && (
            <div
              className={`viewer__aside small-12 viewer__aside__max_width medium-${left}`}
              style={{ flex: "0 0 50% !important", maxWidth: "33% !important" }}
            >
              {children}
            </div>
          )}
        </div>
      </Modal>*/}
    </div>
  );
};

export default NewsletterSettings;
